import api from './api';

export interface Package {
  id: number;
  name: string;
  duration_days: number;
  is_trial: number;
  is_default: number;
  description: string | null;
  sort_order: number;
  is_active: number;
  created_at: string;
  updated_at: string;
  user_count?: number;
}

export interface CreatePackageData {
  name: string;
  duration_days: number;
  is_trial?: boolean;
  is_default?: boolean;
  description?: string;
  sort_order?: number;
}

export interface UpdatePackageData extends Partial<CreatePackageData> {
  is_active?: boolean;
}

export const packagesService = {
  async list(): Promise<Package[]> {
    const response = await api.get<{ success: boolean; data: Package[] }>('/packages');
    return response.data.data;
  },

  async get(id: number): Promise<Package> {
    const response = await api.get<{ success: boolean; data: Package }>(`/packages/${id}`);
    return response.data.data;
  },

  async create(data: CreatePackageData): Promise<Package> {
    const response = await api.post<{ success: boolean; data: Package }>('/packages', data);
    return response.data.data;
  },

  async update(id: number, data: UpdatePackageData): Promise<Package> {
    const response = await api.put<{ success: boolean; data: Package }>(`/packages/${id}`, data);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/packages/${id}`);
  },

  async setDefault(id: number): Promise<void> {
    await api.post(`/packages/${id}/default`);
  },

  async reorder(order: { id: number; sort_order: number }[]): Promise<void> {
    await api.post('/packages/reorder', { order });
  },
};
